import { render, staticRenderFns } from "./update-user-role.vue?vue&type=template&id=21e89e26&scoped=true&"
import script from "./update-user-role.vue?vue&type=script&lang=js&"
export * from "./update-user-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e89e26",
  null
  
)

export default component.exports